import { useCallback, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useGuestDisplay } from '@/hooks/useGuestDisplay';
import { useWakeLock } from '@/hooks/useWakeLock';
import { isAppleMobileDevice } from '@/utils/device';

/**
 * ゲスト画面ようこそダイアログ カスタムフック
 */
export const useWelcomeGuestDialog = () => {
  const [isWelcomeGuestDialogOpen, setIsWelcomeGuestDialogOpen] =
    useState<boolean>(isAppleMobileDevice());

  const { addWakeLock } = useWakeLock();
  const { t } = useTranslation();
  const { isHostSentio } = useGuestDisplay();

  /**
   * ゲスト画面ようこそダイアログのOKボタン押下時の処理
   */
  const clickWelcomeGuestOKButton = useCallback(() => {
    setIsWelcomeGuestDialogOpen(false);
    addWakeLock();
  }, [addWakeLock]);

  /**
   * ホストのプランに応じてダイアログのタイトルを生成
   */
  const title = useMemo(
    () =>
      isHostSentio
        ? t('welcomeGuestDialog.Sentioへようこそ').toString()
        : t('welcomeGuestDialog.ポケトークへようこそ').toString(),
    [isHostSentio, t],
  );

  return { isWelcomeGuestDialogOpen, clickWelcomeGuestOKButton, title };
};
